import { AbstractTileMetrics } from "../tiles.metrics";
import { Ellipsoid } from "../../geodesy/geodesy.ellipsoid";
import { Scalar } from "../../math/math";
export class EPSG3857 extends AbstractTileMetrics {
    constructor(options, ellipsoid) {
        super(options);
        this._ellipsoid = ellipsoid || Ellipsoid.WGS84;
    }
    groundResolution(latitude, levelOfDetail) {
        latitude = Scalar.Clamp(latitude, this.minLatitude, this.maxLatitude);
        return (Math.cos(latitude * Scalar.DEG2RAD) * 2 * Math.PI * this._ellipsoid.semiMajorAxis) / this.mapSize(levelOfDetail);
    }
    getLatLonToTileXYToRef(latitude, longitude, levelOfDetail, tileXY) {
        if (!tileXY)
            return;
        const t = tileXY;
        latitude = Scalar.Clamp(latitude, this.minLatitude, this.maxLatitude);
        longitude = Scalar.Clamp(longitude, this.minLongitude, this.maxLongitude);
        const n = Math.pow(2, levelOfDetail);
        const x = Math.floor(((longitude + 180) / 360) * n);
        const lat_rad = latitude * Scalar.DEG2RAD;
        const y = Math.floor(((1 - Math.log(Math.tan(lat_rad) + 1 / Math.cos(lat_rad)) / Math.PI) / 2) * n);
        t.x = x;
        t.y = y;
    }
    getTileXYToLatLonToRef(x, y, levelOfDetail, loc) {
        if (!loc)
            return;
        const l = loc;
        let n = Math.pow(2, levelOfDetail);
        const lon = -180 + (x / n) * 360;
        n = Math.PI - (2 * Math.PI * y) / n;
        const lat = (180 / Math.PI) * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n)));
        l.lat = lat;
        l.lon = lon;
    }
    getLatLonToPointXYToRef(latitude, longitude, levelOfDetail, pointXY) {
        if (!pointXY)
            return;
        const p = pointXY;
        latitude = Scalar.Clamp(latitude, this.minLatitude, this.maxLatitude);
        longitude = Scalar.Clamp(longitude, this.minLongitude, this.maxLongitude);
        const x = (longitude + 180) / 360;
        const sinLatitude = Math.sin(latitude * Scalar.DEG2RAD);
        const y = 0.5 - Math.log((1 + sinLatitude) / (1 - sinLatitude)) / (4 * Math.PI);
        const mapSize = this.mapSize(levelOfDetail);
        p.x = Math.ceil(Scalar.Clamp(x * mapSize, 0, mapSize - 1));
        p.y = Math.ceil(Scalar.Clamp(y * mapSize, 0, mapSize - 1));
    }
    getPointXYToLatLonToRef(pointX, pointY, levelOfDetail, latLon) {
        if (!latLon)
            return;
        const g = latLon;
        const mapSize = this.mapSize(levelOfDetail);
        const x = Scalar.Clamp(pointX, 0, mapSize - 1) / mapSize - 0.5;
        const y = 0.5 - Scalar.Clamp(pointY, 0, mapSize - 1) / mapSize;
        g.lat = 90 - (360 * Math.atan(Math.exp(-y * 2 * Math.PI))) / Math.PI;
        g.lon = 360 * x;
    }
    getTileXYToPointXYToRef(tileX, tileY, pointXY) {
        if (!pointXY)
            return;
        const p = pointXY;
        const s = this.tileSize;
        p.x = tileX * s;
        p.y = tileY * s;
    }
    getPointXYToTileXYToRef(pointX, pointY, tileXY) {
        if (!tileXY)
            return;
        const t = tileXY;
        const s = this.tileSize;
        t.x = Math.floor(pointX / s);
        t.y = Math.floor(pointY / s);
    }
}
EPSG3857.Shared = new EPSG3857();
//# sourceMappingURL=tiles.geography.EPSG3857.js.map